import React, { Suspense, useEffect } from 'react';
import TableSkeleton from '../../../components/TableSkeleton';
import ReorderTable from '../../../components/ReorderTable';
import { ExtDataGroupsProvider, useExtDataGroups } from '../../../contexts/extractions/ExtDataGroupContext';
import QueryBuilder from './QueryBuilder';
import { useDispatch, useSelector } from 'react-redux';
import ConfirmDialog from '../../../components/ConfirmDialog';
import Spinner from '../../../components/Spinner';
import { createExtDataGroup, updateExtDataGroup } from "../../../store/extDataGroups/actions";
import { Button } from '../../../components/ui/button';
import { setOpenModal } from '../../../store/extVersions/actions';

const ExtDataGroups = () => {
    const dispatch = useDispatch();
    const {
        table,
        columns,
        openAddModal,
        extDataGroups,
        handleDelete,
        handleCloseModal,
        showDeleteConfirmationDialog,
        handleRowReorder,
        getRowId,
    } = useExtDataGroups();

    const { loading, extDataGroup, openModal } = useSelector((state) => state.ExtDataGroups);
    const { columnListValues, fieldValueOptionsMap, extractionViewOnly } = useSelector((state) => state.Extractions);

    useEffect(() => {
        dispatch(setOpenModal(false));
        return () => {
            dispatch(setOpenModal(false));
        };
    }, [dispatch]);
    
    return (
        <>
            <div className="flex justify-between mb-4">
                <div className="text-lg font-semibold text-primary">
                    Please define the data groups here
                </div>
                <Button onClick={openAddModal} disabled={extractionViewOnly}>
                    Add New Data Group
                </Button>
            </div>

            
            <Suspense fallback={<TableSkeleton columns={5} rows={5} headers={["#", "Code", "Title", "Actions"]}/>}> 
                <ReorderTable
                    loading={loading}
                    table={table}
                    data={extDataGroups || []}
                    columns={columns}
                    pagination={false}
                    enableRowReordering={true}
                    onRowReorder={handleRowReorder}
                    getRowId={getRowId}
                />
            </Suspense>

            {/* Single QueryBuilder handles both create and edit */}
            {openModal && (
                <QueryBuilder
                    options={columnListValues}
                    fieldDropdownOptions={fieldValueOptionsMap}
                    editMode={!!extDataGroup}
                    triggerText={extDataGroup ? "Edit" : "Add New Data Group"}
                    titleText={extDataGroup ? "Edit Data Group" : "Add New Data Group"}
                    nameLabel="Data Group Name"
                    namePlaceholder="Enter data group name"
                    createAction={createExtDataGroup}
                    updateAction={updateExtDataGroup}
                    data={extDataGroup}
                    openModal={openModal}
                    disabled={extractionViewOnly}
                    saveInProgress={loading}
                />
            )}
            
            <Suspense fallback={<Spinner/>}>
                <ConfirmDialog
                    open={showDeleteConfirmationDialog}
                    confirmAction={handleDelete}
                    handleClose={e => handleCloseModal('delete')}
                    actionText="Delete"
                    descriptionText="Are you sure you want to delete this Data Group?"
                />
            </Suspense>
        </>
    );
};

const ExtDataGroupsPage = () => {
    return (
        <ExtDataGroupsProvider>
            <ExtDataGroups />
        </ExtDataGroupsProvider>
    );
};

export default ExtDataGroupsPage;